module.exports = __webpack_public_path__ + "static/media/netbeans.8d38a6fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/netbeans.png
// module id = 153
// module chunks = 0